import { RouteObject } from "react-router-dom";

import { ProApp } from "./app";

export const proRoutes: RouteObject = {
  path: "/embedded/pro",
  element: <ProApp />,
};
